import { CreateContainer } from "../../Containers/ContainerCreate";
import EndlessScrollContainer from "../../Containers/EndlessScrollContainer";
import { getTrackArchive } from "../../api/getTracks";

import { ARCHIVE_TRACKS_PER_PAGE } from "../../totdConfig";

class EndlessScrollArchiveTracksContainer extends EndlessScrollContainer {
    constructor(props) {
        super(props);
        this.state = { page: 0, hasMore: false, type: "track", filter: "", items: [], isLoading: false, initialLoading: true };
    }
    fetch = () => {
        if (this.state.isLoading) {
            return;
        }

        this.setState({ isLoading: true });
        this.props.request(this.state.page).then(({ data: { result } }) => {
            const hasMore = result && result.length === ARCHIVE_TRACKS_PER_PAGE;
            const items = [...this.state.items, ...result];
            this.setState({
                items,
                page: (this.state.page += 1),
                hasMore,
                isLoading: false,
                initialLoading: false
            }, () => {
                // Notify parent of items count change
                if (this.props.onItemsChange) {
                    this.props.onItemsChange(items.length);
                }
            });
        }).catch(() => {
            this.setState({ isLoading: false, initialLoading: false });
        });
    };

    componentDidUpdate(prevProps, prevState) {
        // Notify parent when items change (e.g., on initial load)
        if (prevState.items.length !== this.state.items.length && this.props.onItemsChange) {
            this.props.onItemsChange(this.state.items.length);
        }
    }
}

EndlessScrollArchiveTracksContainer.defaultProps = {};
export default CreateContainer(getTrackArchive, EndlessScrollArchiveTracksContainer);

